import React from 'react';

export const renderGridCheckboxColumn = (rowData, col, rowIndex, parentRowData, onCellDataChange) => {
    const isDisabled = col.colSettings ? !col.colSettings.allowEdit : false;
    const isChecked = rowData[col.fieldName];

    const handleToggleChange = () => {
        if (!isDisabled) {
            const newChecked = !isChecked;
            if (col.onChange) {
                col.onChange(rowData, col.fieldName, rowIndex, newChecked, parentRowData);
            }
            if (onCellDataChange) {
                onCellDataChange(rowData, col.fieldName, rowIndex, newChecked, parentRowData);
            }
        }
    };

    const label = col.fieldName === "isRelease" ? (isChecked ? 'Done' : 'Pending') : (isChecked ? 'Active' : 'Inactive');

    return (
        <button
            className={`StatusButton-root ${isChecked ? 'active' : 'inactive'}`}
            onClick={handleToggleChange}
            disabled={isDisabled}
        >
            <div className="StatusButton-label">
                {label}
            </div>
        </button>
    );
};
